import {
  ADD_CUSTOM_LICENSE,
  ADD_CUSTOM_LICENSE_SUCCESSFUL,
  ADD_CUSTOM_LICENSE_FAILURE,
  GET_CUSTOM_LICENSES,
  GET_CUSTOM_LICENSES_SUCCESSFUL,
  GET_CUSTOM_LICENSES_FAILURE,
  UPDATE_CUSTOM_LICENSE,
  UPDATE_CUSTOM_LICENSE_SUCCESSFUL,
  UPDATE_CUSTOM_LICENSE_FAILURE,
  DELETE_CUSTOM_LICENSE,
  DELETE_CUSTOM_LICENSE_SUCCESSFUL,
  DELETE_CUSTOM_LICENSE_FAILURE,
  CLEAR_ALL_MESSAGES,
  CLEAR_ALL_MESSAGES_SUCCESS,
  CLEAR_SUCCESS_MESSAGES,
  CLEAR_SUCCESS_MESSAGES_SUCCESS,
  CLEAR_FAILURE_MESSAGES,
  CLEAR_FAILURE_MESSAGES_SUCCESS,
} from "./actionTypes";

export const addCustomLicense = (customLicense) => {
    console.log("addCustomLicense action, customLicense :: ", customLicense);
    return {
      type: ADD_CUSTOM_LICENSE,
      payload: { customLicense },
    };
}

export const addCustomLicenseSuccessful = () => {
  console.log("addCustomLicenseSuccessful action");
  return {
    type: ADD_CUSTOM_LICENSE_SUCCESSFUL,
    payload: {},
  };
};

export const addCustomLicenseFailure = (error) => {
  console.log("addCustomLicenseSuccessful action, error :: ", error);
  return {
    type: ADD_CUSTOM_LICENSE_FAILURE,
    payload: { error },
  };
};

export const getCustomLicenses = (orgcode) => {
  console.log("getCustomLicenses action");
  return {
    type: GET_CUSTOM_LICENSES,
    payload: { orgcode },
  };
};

export const getCustomLicensesSuccessful = (customLicenses) => {
  console.log("getCustomLicensesSuccessful action");
  return {
    type: GET_CUSTOM_LICENSES_SUCCESSFUL,
    payload: { customLicenses },
  };
};

export const getCustomLicensesFailure = (error) => {
  console.log("getCustomLicensesFailure action, error :: ", error);
  return {
    type: GET_CUSTOM_LICENSES_FAILURE,
    payload: { error },
  };
};

export const updateCustomLicense = (customLicense) => {
  console.log("updateCustomLicense action, customLicense :: ", customLicense);
  return {
    type: UPDATE_CUSTOM_LICENSE,
    payload: { customLicense },
  };
};

export const updateCustomLicenseSuccessful = () => {
  console.log("updateCustomLicenseSuccessful action");
  return {
    type: UPDATE_CUSTOM_LICENSE_SUCCESSFUL,
    payload: {},
  };
};

export const updateCustomLicenseFailure = (error) => {
  console.log("updateCustomLicenseSuccessful action, error :: ", error);
  return {
    type: UPDATE_CUSTOM_LICENSE_FAILURE,
    payload: { error },
  };
};

export const deleteCustomLicense = (orgCode, licenseName) => {
  console.log("deleteCustomLicense action");
  return {
    type: DELETE_CUSTOM_LICENSE,
    payload: { orgCode, licenseName },
  };
};

export const deleteCustomLicenseSuccessful = () => {
  console.log("deleteCustomLicenseSuccessful action");
  return {
    type: DELETE_CUSTOM_LICENSE_SUCCESSFUL,
    payload: {},
  };
};

export const deleteCustomLicenseFailure = (error) => {
  console.log("deleteCustomLicenseSuccessful action, error :: ", error);
  return {
    type: DELETE_CUSTOM_LICENSE_FAILURE,
    payload: { error },
  };
};

export const clearAllCustomLicenseMessages = () => {
  return {
    type: CLEAR_ALL_MESSAGES,
    payload: {},
  };
};

export const clearAllCustomLicenseMessagesSuccess = () => {
  return {
    type: CLEAR_ALL_MESSAGES_SUCCESS,
    payload: {},
  };
};

export const clearSuccessCustomLicenseMessages = () => {
  return {
    type: CLEAR_SUCCESS_MESSAGES,
    payload: {},
  };
};

export const clearSuccessCustomLicenseMessagesSuccess = () => {
  return {
    type: CLEAR_SUCCESS_MESSAGES_SUCCESS,
    payload: {},
  };
};

export const clearFailureCustomLicenseMessages = () => {
  return {
    type: CLEAR_FAILURE_MESSAGES,
    payload: {},
  };
};

export const clearFailureCustomLicenseMessagesSuccess = () => {
  return {
    type: CLEAR_FAILURE_MESSAGES_SUCCESS,
    payload: {},
  };
};